import { gql } from "@apollo/client";

export const RESEND_VERFICATION_EMAIL = gql`
  mutation ResendEmailMutation($email: String!) {
    sendVerificationEmail(email: $email) {
      message
    }
  }
`;
